module.exports = __webpack_public_path__ + "static/media/books_background.89f66734.svg";